
import { createSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IPlateNumberData } from './http/search-by-plate.http';
import useHttp from './useHttp';
import { IHttpResponse } from 'utils/http';
import { ICars } from './http/search-by-vin.http';
import { notify } from 'utils/marketplace';


const useCirrusPlateNumber = (userReady: boolean): boolean => {
  const navigate = useNavigate();

  const http = useHttp();
  const [plateData, setPlateData] = useState<IPlateNumberData>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const registration_plate = localStorage.getItem('cirrus_plate_number') || null;
  const user = JSON.parse(localStorage.getItem('userData')!);

  useEffect(() => {

    if (!userReady) {
      setIsLoading(false);

      return;
    }

    if (registration_plate != null && registration_plate !== '' && registration_plate !== 'null') {

      if (user?.client_settings.plate_number_search !== true && userReady) {
        setIsLoading(false);
        localStorage.removeItem('cirrus_plate_number');
        notify('Plate number search is disabled for this user.', 'error');

        return;
      }

      http.searchByPlate.search({ registration_plate: registration_plate })
        .then((res: IHttpResponse<IPlateNumberData>) => {
          setPlateData(res.data);
        }).catch(() => {
          setIsLoading(false);
          localStorage.removeItem('cirrus_plate_number');
          notify('Error fetching vehicle data by plate number.', 'error');
        });

    } else {
      setIsLoading(false);

      localStorage.removeItem('cirrus_plate_number');

      return;

    }
  }, [registration_plate, userReady]);

  useEffect(() => {

    if (plateData && plateData.cars && plateData.cars.length > 0) {

      plateHandler(plateData?.cars[0]);

    }

    if (plateData && plateData.trucks && plateData.trucks.length > 0) {
      plateHandler(plateData?.trucks[0]);
    }

  }, [plateData]);

  const plateHandler = (car: ICars) => {

    if (registration_plate && car) {
      navigate({
        pathname: `/reliable/rmi/${car.id}/catalogs/parts`,
        search: createSearchParams({
          source: car.source,
          vehicle_identifier: car.vehicle_identifier ?? '002',
          registration_plate: registration_plate
        }).toString(),
      });
      localStorage.removeItem('cirrus_plate_number');
      setIsLoading(false);
    } else {
      setIsLoading(false);
      localStorage.removeItem('cirrus_plate_number');

    }

    return;

  };


  return isLoading;

};

export default useCirrusPlateNumber;
